const parseTime = (isoDate) => {
  const fullDate = new Date(isoDate)
  const hours = (`0${fullDate.getHours()}`).slice(-2)
  const minutes = (`0${fullDate.getMinutes()}`).slice(-2)
  const seconds = (`0${fullDate.getSeconds()}`).slice(-2)
  return `${hours}:${minutes}:${seconds}`
}
export default parseTime
